import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faChevronDown,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../constants/styles";

export default function ExpandableSection(props) {

  var {
    title,
    buttonLabel,
    onButtonClick,
    defaultExpanded,
    children
  } = props;
  
  var [expanded, setExpanded] = useState(
    defaultExpanded === true
  );


  return (
    <div style={{ marginBottom: "24px", marginLeft:'20px', marginTop:'20px',  marginBottom:'20px',borderRadius:'10px', boxShadow:'0 6px 16px rgba(0,0,0,0.25)',  background: ADMIN_PANEL_BACKGROUND_COLOR }}>

      {/* HEADER */}
	  <div
	    onClick={function () {
	      setExpanded(!expanded);
	    }}
	    style={{
	      cursor: "pointer",
	      display: "flex",
	      justifyContent: "space-between",
	      alignItems: "center",

	      height: "56px",              // 🔑 FIXED HEIGHT
	      padding: "0 24px",           // 🔑 HORIZONTAL ONLY

	      background: expanded
	        ? "linear-gradient(180deg, #2F80ED 0%, #1C5FD4 100%)"
	        : GREY_GRADIENT_PANEL_BACKGROUND,
	      color: expanded ? "#ffffff" : "#111",

	      transition: "background 0.25s ease, box-shadow 0.25s ease",
		  borderRadius:'10px'
	    }}
	  >

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <FontAwesomeIcon
            icon={expanded ? faChevronDown : faChevronRight}
            style={{ fontSize: "14px" }}
          />
          <h4 style={{ margin: 0 }}>{title}</h4>
        </div>

        {expanded && buttonLabel && (
          <button
            onClick={function (e) {
              e.stopPropagation();
              if (onButtonClick) {
                onButtonClick();
              }
            }}
            style={{
			  width:'200px',
              background: "linear-gradient(180deg, #2F80ED 0%, #1C5FD4 100%)",
              color: "white",
              border: "none",
              borderRadius: "6px",
              padding: "8px 14px",
              fontSize: "13px",
              fontWeight: 600,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <FontAwesomeIcon icon={faPlus} />
            {buttonLabel}
          </button>
        )}
      </div>

      {/* BODY */}
      {expanded && (
        <div
          style={{
            padding: "px",
            borderRadius: "0 0 8px 8px"
          }}
        >
          {children}
        </div>
      )}

    </div>
  );
}
